module.exports = __webpack_public_path__ + "assets/img/register-verification-shield.389184ad.svg";